import { createStore } from 'vuex'

export default createStore({
  state: {
    token:"",
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
